/**
 * @file: axios请求
 * @author: wangzhenhai02@baidu.com
 * @Date: 2021-08-12 21:32:19
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-04-16 20:34:29
 * @FilePath: /console-znzs/src/utils/request.js
 */
import Vue from 'vue';
import axios from 'axios';
import Cookies from 'js-cookie';
import {isTourist, isDev} from './env';
import {TRACE_SCENE} from './enum';

// 这里是配置项
export const service = axios.create({
    baseURL: '/api/v1/znzs/user',
    timeout: 60000,
});

/**
 * 添加跟踪数据到请求头
 * @param {*} config
 */
function addTraceDataToHeader(config) {
    // 旧版现在只有IM模式，暂时不添加分析数据
    if (
        sessionStorage.getItem('__ZNZS_LEGACY') === 'false'
        // 查看知识详情的接口不启用统计
        && !config.disableMonitor
    ) {
        config.headers['x-bce-scene'] = window.fromConfirmTicket
            ? TRACE_SCENE.CONFIRM_TICKET : TRACE_SCENE.ZNZS;
        // 详见 /console-znzs/new_src/store/commonStore.js
        let traceSource = localStorage.getItem('__ZNZS_TRACE_PAGE_SOURCE');
        traceSource = traceSource ? encodeURIComponent(traceSource) : '';
        config.headers['x-bce-source'] = traceSource;

        const monitorPageInfo = window.__MONITOR__PAGE_VIEW_INFO__();
        config.headers['x-bce-pvid'] = monitorPageInfo?.pageViewId;
        config.headers['x-bce-ssid'] = monitorPageInfo?.siteSessionId;
    }
}

// 拦截请求
service.interceptors.request.use(
    config => {
        addTraceDataToHeader(config);

        // 判断是否含有token进行拦截
        let t = localStorage.getItem('tokenNow');
        if (t) {
            config.headers.tokenNow = t;
        }
        else {
            // router.replace({path: '/'})
        }
        if (isTourist) {
            config.headers['x-bce-userId'] = Cookies.get('BAIDUID');
        }
        // 添加百度云前端请求头安全校验
        config.headers.csrftoken = Cookies.get('bce-user-info');

        // 添加头，api接口会走开发接口
        // if (process.env.VUE_APP_ENV === 'develop') {
        //     config.headers['X-Bce-Access-Version'] = 'ZNZS:beta';
        // }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// 拦截响应
service.interceptors.response.use(
    response => {
        if (response.data.success === false
            && response.data.message
            && response.data.message.redirect
        ) {
            location.href = response.data.message.redirect;
        };
        return response.data;
    },
    err => {
        let message = '抱歉，网络好像出问题了，请刷新重试！';
        let type = 'info';
        if (err.response?.status === 400) {
            message = err.response.data.message;
            type = 'error';
        }
        return Promise.reject(err);
    }
);

export default service;
